import { type Route } from '@angular/router';
import { CategoryFormServiceToken } from '../../common/category-details/abstract-category-form-service.token';
import { locationsCategoryRoutes } from './category/locations-category.routes';
import { LocationsCategoryFormService } from './service/locations-category-form.service';
import { hasStringPathParamCanActivateGuard } from '@pct/ng-core-router';
import { dirtyCheckCanDeactivateGuard } from '../../common/dirty-check/dirty-check';

export const locationsRoutes: Route[] = [
  {
    path: '',
    loadComponent: () => import('./list/locations-list.component'),
    pathMatch: 'full',
  },
  {
    path: 'category',
    children: locationsCategoryRoutes,
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.LIST',
    providers: [{ provide: CategoryFormServiceToken, useClass: LocationsCategoryFormService }],
  },
  {
    path: 'new',
    loadComponent: () => import('./details/location-details.component'),
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: ':id',
    loadComponent: () => import('./details/location-details.component'),
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [dirtyCheckCanDeactivateGuard('HasDirtyCheck')],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
